// extracted by mini-css-extract-plugin
export default {"page":"style_page__70Vl1","card":"style_card__0v5fG","banner":"style_banner__qARPH","grid":"style_grid__naI0T","sensorCard":"style_sensorCard__pQNzy"};